import { Metamodel } from '../base/model';
import { AzureDataExplorerLinkedService } from './azure-data-explorer.linkedservice';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { IAttribute, IValidationContext, IViolation } from '../base/annotation';
import { GlobalVariables } from '../../constants/globals';
import { validateLinkedServiceProperties } from '../../shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: ModelConstants.kustoDatabaseLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.KustoDatabase_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.KustoDatabase_DisplayText)
    ],
    validator: KustoDatabaseLinkedService.validateKustoDatabaseLinkedService
})
export class KustoDatabaseLinkedService extends AzureDataExplorerLinkedService {
    public static ARTIFACT_ID: IAttribute;
    public static WORKSPACE_ID: IAttribute;
    public static ENDPOINT: IAttribute;

    public static async validateKustoDatabaseLinkedService(
        linkedService: KustoDatabaseLinkedService,
        context: IValidationContext
    ): Promise<IViolation[]> {
        if (GlobalVariables.isTrident) {
            return validateLinkedServiceProperties(linkedService, [
                KustoDatabaseLinkedService.ARTIFACT_ID,
                KustoDatabaseLinkedService.WORKSPACE_ID,
                KustoDatabaseLinkedService.MODEL.attribute('endpoint')
            ]);
        }

        return undefined;
    }

    public override readonly tridentArtifactType: 'KustoDatabase' = ModelConstants.kustoDatabaseArtifactType;

    @Metamodel.attribute({
        display: format(shellStringResources.ObjectIdLabel, shellStringResources.KustoDatabase_DisplayText),
        templatable: true,
        association: 'ARTIFACT_ID'
    })
    public artifactId: string;

    @Metamodel.attribute({
        display: shellStringResources.WorkspaceId,
        association: 'WORKSPACE_ID',
        templatable: true
    })
    public workspaceId: string;

    @Metamodel.attribute({
        display: shellStringResources.QueryServiceURI,
        association: 'ENDPOINT',
        templatable: true
    })
    public endpoint?: string;
}
